export enum StorageKeys {
  CookiesConsent = 'cookiesConsent',
  HasEverLoggedIn = 'hasEverLoggedIn',
}
